import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Switch, Route} from 'react-router-dom';
import StockTaking from './scenes/StockTaking';
import {hasPermission} from '../../reducer';
import {push} from 'react-router-redux';


class Inventory extends Component {

    componentDidMount(){
        if(!this.props.hasPermission){
            this.props.redirectNoPermission();
        }
    }

    render() {

        return (
            <Switch>
                <Route path={'/'} component={StockTaking}/>
            </Switch>
        );
    }
}

const mapStateToProps = state => ({
    hasPermission: hasPermission(state,'stockTaking')
});

const mapDispatchToProps = (dispatch) => {
    return({
        redirectNoPermission: ()=>(dispatch(push('/')))
    });
}

export default  connect(
    mapStateToProps,
    mapDispatchToProps
)(Inventory);



// WEBPACK FOOTER //
// ./src/scenes/Inventory/index.js